import * as React from 'react';
import SvgIcon from '../../SvgIcon';
const SvgStaple = (props)=>/*#__PURE__*/ React.createElement(SvgIcon, {
        ...props,
        viewBox: "0 0 24 24"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M1.92 8.37c-4.13-3.94-.31-7-.31-7C4.5-1.4 9.22.9 9.22.9l13.63 13.2c3 4.07-.9 7.75-.9 7.75a10.7 10.7 0 0 1-8.47 1.95L2.37 14a1.6 1.6 0 0 1-.62-1.73 1.39 1.39 0 0 1 1.89.08l9.91 9c3.29 2.76 7-.78 7-.78 3.4-2.86 1.21-4.95 1.21-4.95L8.61 3C6.11.88 3.14 3 3.14 3c-2.29 2.2-.22 3.67-.22 3.67l8.6 7.91c1.59 2.3 3.12.67 3.12.67 1.24-1.1-1.06-2.58-1.06-2.58L8.12 7.54c-.88-.75-.45-1.23-.3-1.44a1.22 1.22 0 0 1 1.62.07s5.58 5.34 6 5.55c0 0 2.88 2.61.51 4.61a3.73 3.73 0 0 1-5.28 0Z"
    }));
export default SvgStaple;
